import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './BlockDeals.css'
import Pagination from '../../CommonUI/Pagination/Pagination';
import { useLocalStorage } from "../../utils/useLocalStorage";
import MarketEquity from "../MarketEquity";
import { Vortex } from 'react-loader-spinner'

function BlockDeals() {
    const [currentPage, setCurrentPage] = useState(1);
    let optionInfoMarket = "Block Deals";
    let optionTypeComp = "Daily Market Tracker";
    const [cocode, setcocode] = useLocalStorage("cocode", "");
    const [data, setData] = useState([])
    const [groupValue, setGroupValue] = useState('BSE')
    const { BaseURL } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);
    let getData, getDataGroup;
    let PageSize = 5;

    useEffect(() => {
        setloadingshow(true)
        // setTimeout(()=>{

       
        if (groupValue === "BSE") {
            const getUrl = BaseURL + "BlockDeals";
            fetch(`${getUrl}/${groupValue}/BLOCK/-`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    // console.log(getData, "getDataBSE")
                    setloadingshow(false)
                })
                .catch((error) => {
                });
        } else {
            const getUrl = BaseURL + "BlockDeals";

            fetch(`${getUrl}/${groupValue}/BLOCK/-`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false)
                    // console.log(getData, "getDataNSE")
                })
                .catch((error) => {
                });
        }

    // },5000)
    }, [groupValue,])

    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
    const routeChange = (event) => {
        const compcocode = event.currentTarget.dataset.id;
        const compcode_array = compcocode.split('-');
        const getCoCodeId = compcode_array[0].replace(/ /g, '-').replace('&', 'and').replace('+', '');
        setcocode(compcode_array[1]);
        window.open("/stocks/" + getCoCodeId.toLowerCase(), '_blank');
    };
    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Block Deals</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='gainer-loser-sc'>
                            <div className='gainer-header'>
                                <h2><span>Block Deals</span></h2>
                            </div>
                            <MarketEquity optionInfoMarket={optionInfoMarket} optionTypeComp={optionTypeComp} />
                            <div className='gainer-table-main'>
                                <div className='exchange-right exchange'>
                                    <div className='holidays-inner-select'>
                                        
                                        {/* aria-label="nse bse" */}
                                        <select aria-label="nse bse" onChange={(event) => { setGroupValue(event.target.value); }}>
                                            <option value="BSE" selected>BSE</option>
                                            <option value="NSE">NSE</option>
                                        </select>
                                    </div>
                                </div>
                                {/* <hr className="hrBlock"></hr> */}
                                <div className='exchange-table table-responsive'>
                                    <table className='table'>
                                        <thead>
                                            <tr>
                                                <th className='text-left'>Company Name</th>
                                                <th className='text-center'>Date</th>
                                                <th className='text-left'>Client Name</th>
                                                <th className='text-left'>Deal Type</th>
                                                <th className='text-right'>Quantity (No’s)</th>
                                                <th className='text-right'>Price(₹)</th>
                                                {/* <th className='text-right'>Change(&#8377;/%)</th> */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentTableData && currentTableData.map(
                                                ({ Date, CO_CODE, scripname, clientname, buysell, avg_price, Serial, qtyshares }) => (
                                                    <tr>
                                                        <td className="text-left">{scripname}</td>
                                                        <td className="text-right"> {Date.split('T')[0]}</td>
                                                        <td className="text-left"> {clientname}</td>
                                                        <td className='text-left'>{buysell}</td>
                                                        <td className='text-right'>{(qtyshares != null) ? qtyshares.toLocaleString("en-us") : 0}</td>
                                                        <td className='text-right'>{(avg_price != null) ? avg_price.toFixed(2) : 0}</td>
                                                    </tr>
                                                )
                                            )
                                            }
                                        </tbody>
                                    </table>
                                    {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                                    </div>
                                    {(data != null && data != []) ?
                                        <Pagination
                                            className="pagination-bar_peer"
                                            currentPage={currentPage}
                                            totalCount={(data.length != null) ? data.length : 0}
                                            pageSize={PageSize}
                                            onPageChange={page => setCurrentPage(page)}
                                        /> : <p className="errorPeer"> No Data Found !!! </p>}
                                
                            </div>
                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default BlockDeals